import Link from "next/link";
import Imagic from "../../../../../components/imagic/imagic";
import { CategoryModel } from "../../../../../models/home-rows";
import { trackEvent } from "../../../../../services/ga-services";
import { ROUTES } from "../../../../../services/router-services";
interface CharacterProps {
  character: CategoryModel;
}

function Character2({ character }: CharacterProps) {
  return (
    <Link
      prefetch={false}
      href={ROUTES.category(character?.title_en ? character?.title_en : "", character?.id)}
    >
      <a
        onClick={() => {
          trackEvent("Home Character", character?.title ?? "");
        }}
      >
        {character?.icon && (
          <Imagic
            src={character.icon}
            alt={character?.title}
            title={character?.title}
            width="153"
            height="153"
            priority
            //loader={simpleLoader}
          />
        )}
      </a>
    </Link>
  );
}

export default Character2;
